module.exports = __webpack_public_path__ + "img/supplySolutions2.041c69e8.png";